import getWithToken from './base/get-with-token'

const getDataNoneRevenueWaterByZone = (date, searchData) => getWithToken(`/dashboard/none-revenue-water-by-zone?date=${date}`)(searchData)

export default getDataNoneRevenueWaterByZone